import { ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ToasterType } from './toaster';
import { CommonService } from 'abs-ngx-library/src/lib/core';

declare let $: any;

@Component({
  selector: 'app-toaster-al-v1',
  templateUrl: './toaster-al-v1.component.html',
  styleUrls: ['./toaster-al-v1.component.scss']
})
export class ToasterALV1Component implements OnInit {
  @Input() data;
  @Input() options;
  @Input() isOpen: boolean = false;
  @Input() isToasterALV2: boolean = false;

  @Output() closeToaster = new EventEmitter();
  isChecked: boolean = false;
  isLearnMoreExpanded: boolean = false;

  toasterTypeEnum = ToasterType;
  constructor(private elementRef: ElementRef, private _commonService: CommonService) {
    /* istanbul ignore next */
  }

  ngOnInit(): void {
    setTimeout(() =>{
      if(this.data.title === 'order-amends-ota'){
        $("#toasterCloseBtnv2").focus();
      }
      else if(this.data.interactiveElementLink) {
        $("#toasterIntElem").focus();
      }
      else {
        $("#toasterMessagev2").focus();
      }
      this.trackAnalyticsEventsOnLoad();
    }, 200);
  }

  // Make active selected flow item
  @HostListener('document:click', ['$event'])
  onMouseUp(e: any): void {
    if (this.isOpen) {
      const container = this.elementRef.nativeElement;
      !container.contains(e.target) && this.data.title !== 'order-amends-ota' && this.closeToasterEvent();
    };
  }

  closeToasterEvent(action: string = null,shouldCallAfterCloseCallbackFn=false) {
    this.closeToaster.emit({
        shouldCallCallback: shouldCallAfterCloseCallbackFn,
        callBackAction: action ? action : {}
    });
    if (this.isLearnMoreExpanded) this.isLearnMoreExpanded = false;
    if (this.isChecked) this.isChecked = false;
    if (!action && (this.data.toastType === 'email_optin_success' || this.data.toastType === 'text_optin_success')) {
      this.trackAnalyticsEvents('confirm');
    }
  }

    onKeyDown($event){
    const focusableElements = 'button:not([disabled])';
    this._commonService.handleTabFocus($event, `#toasterAlV2`, document.getElementById(`toasterAlV2`).parentElement, focusableElements);
  }


  interactiveElementEvent() {
    if(this.data.interactiveElementLink) {
        window.open(this.data.interactiveElementLink);
    }
    else if(this.data.title === 'order-amends-ota'){
      if(this.data.interactiveElement === "Go to chat"){
        this._commonService.dispatchCustomOneTimeEvent('productCardComponentUpdate','goToChat', {});
      }  
      this.closeToasterEvent(this.data.interactiveElement, true);
    }
    else {
      this.closeToasterEvent(null, true);
      this._commonService._toasterInteractiveElement.next(true);
    }
  }

  rollBackFocusClose() {
    $("#toasterTextBtn").focus();
  }

  onClickOfCheckbox() {
    this.isChecked = !this.isChecked;
    this.isLearnMoreExpanded = !this.isLearnMoreExpanded;
  }

  onClickExpandCollapse() {
    this.isLearnMoreExpanded = !this.isLearnMoreExpanded;
    this.trackAnalyticsEvents('learn-more');
  }

  // The control is an anchor for styling, so Enter/Space have to be wired up manually
  onLearnMoreKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      this.onClickExpandCollapse();
    }
  }

  get learnMoreAriaLabel(): string {
    const optinChannel = this.data?.toastType?.indexOf('text') === 0 ? 'promotional text messages' : 'promotional emails';
    return `Learn more about weekly ads and ${optinChannel}`;
  }

  trackAnalyticsEvents(action?: string, actionType?: string, isLearnMoreExpanded?: any) {
    if (window && window['AB'] && window['AB']['DATALAYER'] && action) {
      const page = this.data?.calledBy === 'weeklyad' ? 'weekly-ad' : this.data?.calledBy === 'account' ? 'account' : '';
      let isExpanded = isLearnMoreExpanded || this.isLearnMoreExpanded;
      
      if ((actionType === 'checkbox' && !this.isChecked) || actionType !== 'checkbox') {
        if (action === 'confirm' && window['appEventData'] && window['appEventData'][window['appEventData'].length - 1]?.link?.linkName?.indexOf('exp-') != -1) {
          isExpanded = true;
        } 

        window['AB']['DATALAYER'].setLinkClickEvents(`${page}|${isExpanded ? 'exp-' : ''}${this.data?.toastType === 'email_optin' || this.data.toastType === 'email_optin_success' ? 'email' : this.data?.toastType === 'text_optin' || this.data.toastType === 'text_optin_success'? 'sms' : ''}-${action}`, true);
      }
    }
  }

  trackAnalyticsEventsOnLoad() {
    if(this.data.title === 'order-amends-ota') {
      if(window && window['AB'] && window['AB']['DATALAYER']) {
        const formattedMsg = (this.data.message || '').toLowerCase().replace(/\s+/g, '-');
        window['AB']['DATALAYER'].setUserMessageEvents(`toast|${formattedMsg}`);
      }
    }
  }

}
